import { render, staticRenderFns } from "./AssessmentForm.vue?vue&type=template&id=5a1f79c3&scoped=true&"
import script from "./AssessmentForm.vue?vue&type=script&lang=ts&"
export * from "./AssessmentForm.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentForm.vue?vue&type=style&index=0&id=5a1f79c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f79c3",
  null
  
)

export default component.exports